import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  label: PropTypes.string
};

const defaultProps = {
  label: ""
};

const SVGTypeButton = React.forwardRef(
  ({ label, SVGIcon, children, ...props }, ref) => {
    return (
      <label {...props}>
        <div className={"svgContainer"}>{SVGIcon && <SVGIcon />}</div>
        <div className={"buttonLabel"}>
          <span>{label}</span>
        </div>
        {children && children}
      </label>
    );
  }
);

SVGTypeButton.displayName = "SVGTypeButton";
SVGTypeButton.propTypes = propTypes;
SVGTypeButton.defaultProps = defaultProps;

export default SVGTypeButton;
